import Vue from 'vue'
import VueRouter from 'vue-router'
import AuthGuard from "./auth-guard"
import DevGuard from "./Dev-guard"

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        redirect: '/cards'
    },
    {
        path: '/dev',
        name: '(Page Under Development)',
        component: () => import('../views/Development.vue')
    },
    {
        path: '/home',
        name: 'Home',
        component: () => import('../views/Home.vue')
    },
    {
        path: '/settings',
        name: 'Settings',
        component: () => import('../views/Settings.vue'),
        beforeEnter: DevGuard
    },
    {
        path: '/profile',
        name: 'Profile',
        component: () => import('../views/Profile.vue'),
        // beforeEnter: AuthGuard
        beforeEnter: DevGuard
    },
    {
        path: '/cards',
        name: 'Cards',
        component: () => import('../views/Cards.vue')
    },
    {
        path: '/decks',
        name: 'Decks',
        component: () => import('../views/Decks.vue'),
        beforeEnter: AuthGuard
    },
    {
        path: '/collections',
        name: 'Collections',
        component: () => import('../views/Collections.vue'),
        // beforeEnter: AuthGuard
        beforeEnter: DevGuard
    },
    {
        path: '/trading',
        name: 'Trading',
        component: () => import('../views/Trading.vue'),
        // beforeEnter: AuthGuard
        beforeEnter: DevGuard
    },
    {
        path: '/resources',
        name: 'Resources',
        component: () => import('../views/Resources.vue')
    },
    {
        path: '/about',
        name: 'About',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import('../views/About.vue')
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('../views/LoginRegister.vue')
    },
];

const router = new VueRouter({
    mode: 'history',
    routes
});

export default router
